export const defaultInformationArchitectureConfiguration = {
    tabBarHeightMobile: 0,
    tabBarHeightTablet: 0,
    tabBarHeightDesktop: 0,
    navigationBarHeightDesktop: 0,
};
